export const BENEFITS =
    [
        {
            key: 'online_consults',
            title: 'Online Consults',
            image: "../assets/homepage/ic_online.svg",
            content: 'Members can avail Online consultations.',
        },
        {
            key: "hospicash",
            title: 'HospiCash Benefits',
            image: "../assets/homepage/ic_online.svg",
            content: 'Claim Hospicash benefits during hospitalisation.',
        },
        {
            key: "all_health_problems",
            title: 'All Your Health Problems Covered',
            image: "../assets/homepage/ic_all.svg",
            content: 'Consult with a doctor from as many as 20 departments at any time.',
        },
        {
            key: "whole_family",
            title: 'For the Whole Family',
            image: "../assets/homepage/ic_for.svg",
            content: 'Benefits can be availed for your family members as per the plan.',
        },

        {
            key: "discount",
            title: 'Discount on Labs & Medicines',
            image: "../assets/homepage/ic_discount.svg",
            content: 'Get up to 70% discount on Labs & 15% discount on medicines.',
        },
        {
            key: "no_entry",
            title: 'No Entry Restrictions',
            image: "../assets/homepage/ic_no_restrictions.png",
            content: 'Available for all age groups including senior citizens.',
        },

    ];
